import React from 'react'
import { ComponentWrapper } from 'ascential-horizon'
import getThemeConfig from '../../providers/config/themeConfig'
import { useHasMounted } from '../../utils/hooks'
import { getUrlByDate } from './dateToUrlMatching'
import Announcement from '../Announcement'
import LivePlayerContent from './LivePlayerContent'

function LivePlayer(content) {
  const hasMounted = useHasMounted()
  if (!hasMounted) {
    return null
  }
  const {
    videoPlatform: { liveTitleUrl },
  } = getThemeConfig()

  const {
    actions,
    announcement,
    interactionTool,
    isAuthorized,
    liveEventDate,
    liveStreamUrls,
    slidoSponsorship,
    slidoUrls,
    user,
    votemoUrls,
  } = content

  const videoUrl = getUrlByDate(liveEventDate, liveStreamUrls)
  const slidoProps = {
    url: getUrlByDate(liveEventDate, slidoUrls),
    banner: slidoSponsorship,
  }
  const votemoProps = {
    url: getUrlByDate(liveEventDate, votemoUrls),
    banner: slidoSponsorship,
  }
  return (
    <div>
      <LivePlayerContent
        interactionTool={interactionTool}
        isAuthorized={isAuthorized}
        liveTitleUrl={liveTitleUrl}
        loggedIn={user.loggedIn}
        login={actions.login}
        slido={slidoProps}
        user={user}
        videoUrl={videoUrl}
        votemo={votemoProps}
      />
      {announcement && (
        <ComponentWrapper columnWidth={[12]}>
          <Announcement {...announcement} />
        </ComponentWrapper>
      )}
    </div>
  )
}

export default LivePlayer
